import { CSSProperties } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Container } from './styles';
import { LinkComposed } from '@/components/shared/LinkComposed';
import { ZoneStageManager } from '../../ZonesManagementRevamped/ZoneStageManager';
import { useFeatureFlag } from '@/hooks';
import { Zone } from '@/__generated__/graphql';

type Props = {
  structure: { id: string; name: string } | undefined;
  zone: Zone | null;
};

export const Breadcrumb = ({ structure, zone }: Props) => {
  const isBetaUser = useFeatureFlag('beta-user');
  const containerStyles: CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '2rem',
    paddingTop: '1rem',
  };

  return (
    <Container style={containerStyles}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" component={LinkComposed} to="/">
          <Typography variant="body1">Platforms</Typography>
        </Link>
        {structure && (
          <Link
            key={'1'}
            component={LinkComposed}
            underline="hover"
            color="inherit"
            to={`/asset-labelling/${structure.id}`}
          >
            <Typography variant="body1">{structure.name}</Typography>
          </Link>
        )}
        {structure && zone && (
          <Link
            key={'2'}
            component={LinkComposed}
            underline="hover"
            color="inherit"
            to={`/asset-labelling/${structure.id}/viewer?zone=${zone.id}`}
          >
            <Typography variant="body1">{zone.name}</Typography>
          </Link>
        )}
      </Breadcrumbs>
      {isBetaUser && <ZoneStageManager />}
    </Container>
  );
};
